import "../js/utils/console-guard.js";
import "../js/utils/sanitizer.js";
import "../js/utils/integrity-checker.js";
import "../js/performance-optimizer.js";
